import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function ForWhom() {
  return <section className="py-20 bg-white px-6" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-92">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-brand-sage-light/30 p-8 md:p-10 rounded-3xl" data-id="element-93">
            <h3 className="text-2xl font-bold mb-8 text-brand-navy" data-id="element-94">
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-95">
              {['Mamás de niños con alta sensibilidad, TDAH o desafíos de procesamiento sensorial.', "Padres que están cansados de los métodos de 'mano dura' que solo rompen el vínculo.", "Mujeres que sienten que 'caminan sobre cáscaras de huevo' en su propia casa esperando la próxima explosión."].map((item, i) => <li key={i} className="flex gap-4" data-id="element-96">
                  <CheckCircle2 className="text-brand-sage shrink-0 mt-1" size={24} data-id="element-97" />
                  <span className="text-brand-navy/80 leading-relaxed" data-id="element-98">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-brand-coral-light/30 p-8 md:p-10 rounded-3xl" data-id="element-99">
            <h3 className="text-2xl font-bold mb-8 text-brand-navy" data-id="element-100">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-101">
              {["Quienes buscan una 'solución mágica' que no requiera cambiar su propia forma de reaccionar.", 'Personas que prefieren la disciplina basada en el castigo físico o la humillación.'].map((item, i) => <li key={i} className="flex gap-4" data-id="element-102">
                  <X className="text-brand-coral shrink-0 mt-1" size={24} data-id="element-103" />
                  <span className="text-brand-navy/80 leading-relaxed" data-id="element-104">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}